/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mailbox",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_maxCapacity",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "targetLimit",
                type: "uint256",
            },
        ],
        name: "RateLimitExceeded",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "filledLevel",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lastUpdated",
                type: "uint256",
            },
        ],
        name: "ConsumedFilledLevel",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "HookSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "IsmSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_oldCapacity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_newCapacity",
                type: "uint256",
            },
        ],
        name: "RateLimitSet",
        type: "event",
    },
    {
        inputs: [],
        name: "DURATION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "calculateCurrentLevel",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "filledLevel",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hookType",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "interchainSecurityModule",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastUpdated",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "localDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mailbox",
        outputs: [
            {
                internalType: "contract IMailbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxCapacity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
        ],
        name: "messageValidated",
        outputs: [
            {
                internalType: "bool",
                name: "validated",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_message",
                type: "bytes",
            },
        ],
        name: "postDispatch",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "quoteDispatch",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "refillRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "setInterchainSecurityModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_capacity",
                type: "uint256",
            },
        ],
        name: "setRefillRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "supportsMetadata",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_consumedAmount",
                type: "uint256",
            },
        ],
        name: "validateAndConsumeFilledLevel",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class RateLimitedHook__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_mailbox, _maxCapacity, overrides) {
        return super.deploy(_mailbox, _maxCapacity, overrides || {});
    }
    getDeployTransaction(_mailbox, _maxCapacity, overrides) {
        return super.getDeployTransaction(_mailbox, _maxCapacity, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=RateLimitedHook__factory.js.map